import axios, { AxiosResponse } from 'axios'
import { FaturaProfissionalDtoView, PageResponseFaturaProfissionalDtoList } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const FINANCEIRO_URL = `${API_URL}/financeiro`
const FINANCEIRO_FATURA_PROFISSIONAL_URL = `${FINANCEIRO_URL}/fatura/profissional`

/**
 * Busca faturas de um profissional
 * @param query string
 * @returns PageResponseFaturaProfissionalDtoList
 */
export const getFaturasProfissional = (
  query: string
): Promise<PageResponseFaturaProfissionalDtoList> => {
  return axios
    .get(`${FINANCEIRO_FATURA_PROFISSIONAL_URL}?${query}`)
    .then((resp: AxiosResponse<PageResponseFaturaProfissionalDtoList>) => resp.data)
}

/**
 * Busca uma fatura de profissional
 * @param idFatura ID da Fatura
 * @returns FaturaProfissionalDtoView
 */
export const getFaturaProfissionalById = (idFatura: number): Promise<FaturaProfissionalDtoView> => {
  return axios
    .get(`${FINANCEIRO_FATURA_PROFISSIONAL_URL}/${idFatura}`)
    .then((resp: AxiosResponse<FaturaProfissionalDtoView>) => resp.data)
}
